import * as React from 'react';
const SvgCancelIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={9} height={9} fill="none" {...props}>
    <path
      fill="#000"
      d="M7.492 8.74 4.998 6.247 2.503 8.74a.882.882 0 0 1-1.248-1.246L3.75 5 1.255 2.505a.883.883 0 0 1 1.248-1.248L4.998 3.75l2.494-2.494a.883.883 0 0 1 1.249 1.248L6.246 5l2.495 2.494A.882.882 0 0 1 7.492 8.74Z"
    />
  </svg>
);
export default SvgCancelIcon;
